module.exports = __webpack_public_path__ + "img/16.2.TN.5d25cd7d.png";